<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">首页主选项信息管理</div>
          <span class="m-title-s">对首页主选项信息新增、编辑、排序等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <div class="m-app-home-opt">主选项样式</div>
        <div class="m-app-home-option">
          <div class="m-app-home-item" v-for="(item, index) in list" :key="index">
            <div class="m-app-home-item-l">
              <div class="m-app-home-icon">
                <img :src="ossURL + item.icon" alt="" width="80" height="80">
              </div>
              <div class="m-app-home-title">{{ item.title }}</div>
            </div>
            <div class="m-app-home-item-r">
              <div style="width: 245px; height: 97px; border: 1px solid #f2f2f2;">
                <img :src="ossURL + item.headImage" alt="" width="245" height="97"
                     onerror="this.style.display='none'">
              </div>
            </div>
            <div class="m-app-home-edit">
              <div class="m-app-home-edit-cont">
                <el-button type="primary" @click="thisForm(item.id)" plain>编辑</el-button>
                <el-button style="margin-left: 20px;" type="danger" @click="thisDel(item.id)" plain>删除</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑栏目 -->
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入标题"></el-input>
            </el-form-item>
            <el-form-item label="图标: " prop="icon">
              <el-upload
                :action="uploadAction"
                :headers="myHeaders"
                accept=".jpg, .png"
                list-type="picture-card"
                :limit="1"
                :file-list="fileLists"
                :on-success="success"
                :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="广告图片: " prop="headImage">
              <div style="display: flex;">
                <div style="width: 40%;">
                  <el-upload
                    drag
                    :action="uploadHeadAction"
                    :headers="myHeaders"
                    accept=".jpg, .png"
                    :limit="1"
                    :file-list="headImgFileLists"
                    :on-success="headImgSuccess"
                    :on-remove="headImgRemove">
                    <div style="font-size: 12px; line-height: 26px;display: flex; flex-wrap: wrap;align-items: center; height: 130px;">
                      <div>
                        <div style="width: 100%;"><i style="font-size: 28px" class="el-icon-upload2"></i></div>
                        <div style="width: 100%;text-align: center;">拖拽或<em style="color: #1c9dff">点击上传</em></div>
                      </div>
                    </div>
                  </el-upload>
                </div>
                <div style="width: 60%">
                  <div style="width: 100%; height: 130px;border-radius: 8px; overflow: hidden;">
                    <img :src="ossURL + form.headImage" alt="" width="100%" height="100%">
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="主题图片: " prop="headImage">
              <el-input v-model="form.headImage" type="text" disabled placeholder="输入主题图片地址"></el-input>
            </el-form-item>
            <el-form-item label="栏目类型: " prop="inType">
              <el-input v-model="form.inType" type="text" placeholder="输入栏目类型"></el-input>
            </el-form-item>
            <el-form-item label="积分限制: " prop="scoreLimit">
              <el-input v-model="form.scoreLimit" type="number" placeholder="输入积分限制"></el-input>
            </el-form-item>
            <el-form-item label="报告价格: " prop="money">
              <el-input v-model="form.money" type="number" placeholder="输入全栏价格"></el-input>
            </el-form-item>
            <el-form-item label="排序: " prop="sort">
              <el-input v-model="form.sort" type="number" placeholder="输入排序"></el-input>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'appHome',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      uploadAction: '',
      uploadHeadAction: '',
      myHeaders: { Authorization: JSON.parse(window.sessionStorage.user).Authorization },
      fileLists: [],
      headImgFileLists: [],
      ossURL: this.$httpConf.ossURL,
      list: [],
      form: {
        id: '',
        inType: '',
        scoreLimit: '',
        title: '',
        money: '',
        icon: '',
        headImage: '',
        sort: '',
        remarks: ''
      },
      rules: {
        inType: [
          { required: true, message: '请输入栏目类型', trigger: 'blur' }
        ],
        scoreLimit: [
          { required: true, message: '请输入积分限制', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传栏目图标', trigger: 'blur' }
        ],
        headImage: [
          { required: true, message: '请输入栏目主题图片', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.uploadAction = this.$httpConf.baseURL + '/appHome/uploadImage'
    this.uploadHeadAction = this.$httpConf.baseURL + '/appHome/uploadHeadImage'
  },
  methods: {
    // 图片上传成功
    success (response, file, fileList) {
      if (file.response.status === 200) {
        this.form.icon = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.dialogImageUrl = this.$httpConf.ossURL + file.response.data
        this.$message.success('上传成功')
      }
    },
    // 删除图片
    handleRemove (file, fileList) {
      this.form.icon = ''
      this.fileLists = []
    },
    // 删除图片
    headImgRemove () {
      this.form.headImage = ''
      this.headImgFileLists = []
    },
    // 图片上传成功
    headImgSuccess (response, file, fileList) {
      if (file.response.status === 200) {
        this.form.headImage = file.response.data
        this.headImgFileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.$message.success('上传成功')
      }
    },
    closeDialog () {
      this.form = {
        id: '',
        inType: '',
        scoreLimit: '',
        title: '',
        money: '',
        icon: '',
        headImage: '',
        sort: '',
        remarks: ''
      }
      this.fileLists = []
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
      this.$refs['form'].resetFields()
    },
    openPopup () {
      this.openState = true
    },
    // 提交信息
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/appHome/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
              } else {
                _this.$message.error(res.msg)
              }
              _this.formLoading = false
            })
        } else {
          return false
        }
      })
    },
    thisForm (id) {
      let _this = this
      _this.formLoading = true
      this.$axios.post('/appHome/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            this.form = res.data
            _this.fileLists = []
            if (res.data.icon !== undefined && res.data.icon !== '') {
              _this.fileLists = [{url: _this.$httpConf.ossURL + res.data.icon}]
            }
            _this.$message.success(res.msg)
            _this.openState = true
          } else {
            _this.$message.error(res.msg)
          }
          _this.formLoading = false
        })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/appHome/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/appHome/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>
<style>
  .m-app-home-opt {
    color: #0084ff;
    margin-bottom: 5px;
    text-align: center;
    font-size: 18px;
  }
  .m-app-home-option {
    width: 100%;
    min-height: 500px;
    border: 1px solid #f2f2f2;
    padding: 20px 10px;
    border-radius: 5px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: flex-start;
  }
  .m-app-home-item {
    width: 23%;
    position: relative;
    border: 2px solid #f2f2f2;
    border-radius: 10px;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
  .m-app-home-item-l {
  }
  .m-app-home-item-r {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .m-app-home-icon {
    text-align: center;
  }
  .m-app-home-title {
    text-align: center;
    font-size: 16px;
  }
  .m-app-home-edit {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(68, 68, 68, 0.5);
    display: none;
    border-radius: 5px;
  }
  .m-app-home-item:hover .m-app-home-edit{
    display: block;
  }
  .m-app-home-edit-cont {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-upload-dragger {
    width: 170px;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/appHome/AppHome.vue